import Vue from 'vue'

import currency from '~/filters/currency';
import sum from '~/filters/sum';
import salutation from '~/filters/salutation';

Vue.filter('currency', currency);
Vue.filter('sum', sum);
Vue.filter('salutation', salutation);
